export default __webpack_public_path__ + "static/media/socialMail.61dc67f7.svg";